module.exports = __webpack_public_path__ + "static/media/gi.9f131397.svg";